'use client'

import KeywordChip from '@/components/KeywordChip'
import { Ai_agent, Anomaly, Boost, Check, Eye, Field, Synonym, Sunrise } from '@indxsearch/pixl'
import ConsoleFeature, { chipClass } from './ConsoleFeature'

// Observr as the console shows it: the observations on a dataset's Status tab (what it read in the
// statistics that morning, on the furniture demo) and the changes it suggests, each waiting for a
// yes. Mirrored, so the console's four sections alternate.
export default function ObservrSection() {
  return (
    <ConsoleFeature
      id="observr"
      mirror
      eyebrow="Watched, flagged, proposed"
      title="Observr"
      href="#pricing"
      linkLabel="In Indx Professional"
      lead="An AI that watches your search. Each morning it reads your datasets' statistics, flags what needs a look, and proposes synonyms, boost rules and field changes. Nothing changes until you say yes."
      chips={<>
        <KeywordChip icon={<Sunrise/>} className={chipClass} style={{ right: '6%', top: '-18px' }}>Every morning</KeywordChip>
        <KeywordChip icon={<Ai_agent/>} tone="mid" className={chipClass} style={{ right: '30%', top: '30%' }}>Discuss it with the agent</KeywordChip>
        <KeywordChip icon={<Check/>} className={chipClass} style={{ left: '30%', top: '62%' }}>Waits for your yes</KeywordChip>
      </>}
      main={{ name: 'observr', alt: "Observations on a dataset's Status tab: sizes typed differently, other shops' names in searches, a query rarely chosen, and an answer about the field setup." }}
      second={{ name: 'observr-proposal', alt: 'Suggested changes: make description searchable with weight 0.5, and pattern with weight 1, each with its reason.' }}
      features={[
        { icon: <Eye/>, label: 'Watches your datasets' },
        { icon: <Anomaly/>, label: 'Flags anomalies' },
        { icon: <Synonym/>, label: 'Proposes synonyms' },
        { icon: <Boost/>, label: 'Proposes boost rules' },
        { icon: <Field/>, label: 'Suggests field changes' },
        { icon: <Check/>, label: 'Changes wait for your yes' },
      ]}
    />
  )
}
